import React from "react";
import { useAppState } from "src/app/state/StateProvider";
import AppRow from "src/commun/composants/grille/AppRow";
import InfoConnexion from "src/pages/infoperso/connexion/InfoConnexion";
import DeleteAccount from "src/pages/infoperso/deleteaccount/DeleteAccount";
import InfoPersoUpdateForm from "src/pages/infoperso/infoperso/InfoPersoUpdateForm";
import styles from "src/pages/infoperso/InfoPerso.scss";
import AppCol from "src/commun/composants/grille/AppCol";

const InfoPerso = () => {
  const [{ user }] = useAppState();
  const readOnly = user!.typePersonne !== "Externe";

  return (
    <span className={`ferge-class`}>
      <AppRow>
        <AppCol md={{ span: 11 }} className={styles.formContainer}>
          <InfoPersoUpdateForm readOnly={readOnly}/>
        </AppCol>
      </AppRow>

      <AppRow>
        <AppCol md={{ span: 11 }} className={styles.formContainer}>
          <InfoConnexion readOnly={readOnly}/>
        </AppCol>
      </AppRow>
      {user!.comptePersonnel && (
        <AppRow className="justify-content-md-center">
          <AppCol md="auto">
            <DeleteAccount/>
          </AppCol>
        </AppRow>
      )}
    </span>
  );
};

export default InfoPerso;